import { Cookie, load as getCookie, SessionStorage } from '@kiwicom/cookies';
import eventPublish, { type SchemaWithoutCommon } from '@kiwicom/event';
import { loadSession } from '@kiwicom/darwin';
import { load as getSession } from '@kiwicom/nitro/lib/services/session/session';
import * as sessionConsts from '@kiwicom/nitro/lib/consts/session';
import { getPlatform } from '@kiwicom/nitro/lib/services/platform/client';
import { isLoggedIn } from '@kiwicom/nitro/lib/services/auth';
import { isBrowser } from '@adeira/js';
import { type Session, sessionDefault } from '@kiwicom/nitro/lib/records/Session';
import initSession from '@kiwicom/nitro/lib/services/session/init';

const platformToDisplayPlatform = {
  android: 'webview-android',
  ios: 'webview-ios',
  web: 'only-web',
};

const isProd = process.env.NODE_ENV === 'production';

enum BusinessEventsPubSubTopic {
  prod = 'projects/plexus-production-bdc7274d/topics/account',
  sandbox = 'projects/plexus-sandbox-58437c0d/topics/account',
}

const getLocaleFromPath = (): string => {
  if (isBrowser()) {
    const pathSegments = window.location.pathname.split('/');
    // The locale is the first segment after the leading slash in our [language] route structure
    if (pathSegments.length > 1 && pathSegments[1]) {
      return pathSegments[1];
    }
  }
  return '';
};

export default function publish(data: SchemaWithoutCommon): void {
  (async () => {
    const userIsLoggedIn = await isLoggedIn().catch(() => false);
    const platform = getPlatform();
    const locale = getLocaleFromPath();
    const abTestsData = loadSession();

    const session: Session = isBrowser()
      ? (() => {
          try {
            return initSession();
          } catch (e) {
            return sessionDefault;
          }
        })()
      : sessionDefault;

    eventPublish(
      isProd ? BusinessEventsPubSubTopic.prod : BusinessEventsPubSubTopic.sandbox,
      {
        ab_tests: abTestsData
          ? Object.entries(abTestsData).map(([name, value]) => ({ name, value: String(value) }))
          : undefined,
        session_id: getSession(sessionConsts?.SESSION_ID) ?? '',
        visitor_id: getCookie(Cookie.USER_ID) ?? '',
        affil_id: getCookie(Cookie.AFFILIATE_ID) ?? 'default',
        account_id: getSession(SessionStorage.ACCOUNT_ID) ?? 'default',
        is_logged_in: userIsLoggedIn,
        market: getCookie(Cookie.KW_MARKET) ?? undefined,
        referrer: document?.referrer ?? undefined,
        user_agent: window?.navigator?.userAgent ?? undefined,
        visitor_session_id: getCookie(Cookie.KW_SESSION_ID) ?? '',
        display_platform: platformToDisplayPlatform[platform] ?? 'only-web',
        url: window?.location?.href ?? undefined,
        language: getCookie(Cookie.LANGUAGE) || '"en-GB"',
        branding_id: typeof window !== 'undefined' ? String(window.__BRAND__?.id) : 'kiwicom',
        locale,
        utm: session.UTMs ?? {},
      },
      data,
    );
  })();
}
